import classNames from 'classnames';

// styles
import s from './FormError.sss';

// types
type FormErrorProps = {
  className?: string;
};

export const FormError: React.FC<React.PropsWithChildren<FormErrorProps>> = ({
  className,
  children,
}) => (
  <div
    className={classNames(s.root, className)}
    data-error='true'
  >
    {children}
  </div>
);
